import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from './BaseComponent';
import { TooltipStore } from '../stores/TooltipStore';
import { ToolsStore } from '../stores/ToolsStore';
import { TooltipIds } from '../constants/TooltipIds';
import { ArchitectureActions } from '../actions/ArchitectureActions';
import { AppConfigurationStore } from '../stores/AppConfigurationStore';
import { CoreTooltip } from './CoreTooltip';

export interface TooltipButtonWallState {
    showTooltip: boolean;
    showButton: boolean;
}
export class ToolbarButtonWall extends BaseComponent<{}, TooltipButtonWallState> {
    public componentWillMount(): void {
        this.addStoreListener(TooltipStore, this.onChange);
        this.addStoreListener(ToolsStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (AppConfigurationStore.getState().architectureAvailable && this.state.showButton) {
            return (
                <div className="toolbar-button-wall" onClick={ArchitectureActions.drawWall}>
                    <div className="toolbar-button-wall-content">
                        <CoreTooltip
                            config={{label: t('Draw another wall'), forceLabel: this.state.showTooltip ? t('Draw another wall') : null}}
                        />
                    </div>
                </div>
            );
        }
        return null;
    }

    protected onChange = (): void => {
        this.setState({
            showTooltip: TooltipStore.getState().activeId === TooltipIds.DRAW_WALL_ICON,
            showButton: ToolsStore.getState().showWallButton
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ToolbarButtonWall.tsx